import "@fancyapps/ui/src/Fancybox/Fancybox.scss"
import "./fancybox-default"
import "../../components/groups/gallery-slider-group/gallery-slider-group--fancybox"
